module.exports = __webpack_public_path__ + "img/promo-md-2x.1d6204af.png";